import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  clearAllSensorData,
  fetchSensorDataStart,
  removeSensorData,
} from "../store/features/customer/sensor/sensorDataSlice";

export const useSensorDataFetch = ({
  sensorIds,
  timeRange,
  accessToken,
  selectedButton,
  scope,
  filtered,
  enabled = true,
}) => {
  const dispatch = useDispatch();
  const requestedSensors = useRef(new Set());
  const { from, to } = timeRange;
  const isFiltered = filtered ?? (selectedButton !== "24h");
  const sensorIdsKey = JSON.stringify(
    [...new Set(sensorIds.filter(Boolean))].sort(),
  );

  useEffect(() => {
    requestedSensors.current = new Set();
    return () => dispatch(clearAllSensorData({ scope }));
  }, [dispatch, scope, accessToken, from, to, isFiltered, enabled]);

  useEffect(() => {
    if (!scope || !enabled || !accessToken) return;

    const selection = new Set(JSON.parse(sensorIdsKey));
    requestedSensors.current.forEach((sensorId) => {
      if (!selection.has(sensorId)) {
        dispatch(removeSensorData({ sensorId, scope }));
      }
    });
    selection.forEach((id) => {
      if (!requestedSensors.current.has(id)) {
        dispatch(fetchSensorDataStart({
          accessToken, id, from, to, filtered: isFiltered, scope,
        }));
      }
    });
    requestedSensors.current = selection;
  }, [dispatch, sensorIdsKey, scope, accessToken, from, to, isFiltered, enabled]);
};
